// Tiny typed-DOM helpers for the plain-DOM controls (no framework).

type ElProps = { [k: string]: string };

export function el<T extends HTMLElement = HTMLElement>(tag: string, props: ElProps = {}): T {
  const node = document.createElement(tag) as T;
  for (const [key, value] of Object.entries(props)) {
    if (key === "textContent") node.textContent = value;
    else node.setAttribute(key, value);
  }
  return node;
}

export function group(label: string, ...children: HTMLElement[]): HTMLElement {
  const wrap = el("div", { class: "group" });
  if (label) wrap.append(el("label", { textContent: label }));
  wrap.append(...children);
  return wrap;
}

export function field(label: string, control: HTMLElement): HTMLElement {
  const wrap = el("div", { class: "field" });
  wrap.append(el("label", { textContent: label }), control);
  return wrap;
}

export function fieldWith(label: string, control: HTMLElement, extra: HTMLElement): HTMLElement {
  const wrap = el("div", { class: "field" });
  wrap.append(el("label", { textContent: label }), control, extra);
  return wrap;
}

export function rowBetween(left: HTMLElement, right: HTMLElement): HTMLElement {
  const wrap = el("div", { class: "drawer-head" });
  wrap.append(left, right);
  return wrap;
}

export function checkbox(label: string): { wrap: HTMLLabelElement; input: HTMLInputElement } {
  const input = el<HTMLInputElement>("input", { type: "checkbox" });
  const wrap = el<HTMLLabelElement>("label", { class: "check" });
  wrap.append(input, document.createTextNode(` ${label}`));
  return { wrap, input };
}

export function selectOf(options: ReadonlyArray<readonly [string, string]>): HTMLSelectElement {
  const sel = el<HTMLSelectElement>("select");
  for (const [value, text] of options) sel.append(el("option", { value, textContent: text }));
  return sel;
}
